/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { TTrafficLog, TTrafficLogIdentifier } from '../traffic-logs.types';

/**
 * Get the unique identifier of a trafficlog, calculated by log_id, service_engine, and vcpu_id.
 */
export const getTrafficLogIdentifier = (log: TTrafficLog): TTrafficLogIdentifier => {
    const {
        log_id: logId,
        service_engine: serviceEngine,
        vcpu_id: vcpuId,
    } = log;

    return `${logId}+${serviceEngine}+${vcpuId}`;
};

/**
 * Retrieve the three parts of a traffic log identifier.
 */
export const retrieveLogIdentifierParts = (logIdentifier: TTrafficLogIdentifier): {
    logId: number;
    serviceEngine: string;
    vcpuId: number;
} => {
    const [logId, serviceEngine, vcpuId] = logIdentifier.split('+');

    return {
        logId: Number(logId),
        serviceEngine,
        vcpuId: Number(vcpuId),
    };
};
